export default "__VITE_ASSET__9bb0f45e__"